import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Statistic, PageHeader, Button, Row, Col } from 'antd';
import Pusher from 'pusher-js/with-encryption';  

const PublicArea = (props) => {
  
    console.log('LOADING PUBLIC AREA')

    let occupancy = props.occupancy

    return ( 

        <Row gutter={8} style={{ paddingTop: '20px' }} key="public">
        <Col span={6}></Col>
        <Col span={12}>
            <PageHeader
                title="Public Area"
            >
                <Row>
                    <Col span={12}>
                        <Statistic title="Current Occupancy" value={occupancy.current_occupancy} valueStyle={{ fontSize: '30px', color: '#1890ff' }} />
                    </Col>
                    <Col span={12}>
                        <Statistic title="Daily Entrances" value={occupancy.daily_entrances} valueStyle={{ fontSize: '30px', color: '#1890ff' }} />
                    </Col>
                </Row>
            </PageHeader>
        </Col>
        <Col span={6}></Col>
    </Row>
    );
};

export default PublicArea;